<template>
  <div>

        <section >
                <div class="">
                    <!-- Mobile action buttons -->
                    <div class="d-flex d-md-none gap-2 mb-3" v-if="!isDetailClient">
                        <template v-if="helper.checkAccess('create_orders') != -1">
                            <button @click="create" class="btn btn-sm btn-success flex-grow-1">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('order')}}</span>
                            </button>
                        </template>
                        <div v-if="role === 'owner' || role === 'admin'" class="dropdown">
                            <button class="btn btn-sm btn-outline-secondary d-flex align-items-center justify-content-center" type="button" data-bs-toggle="dropdown" aria-expanded="false" style="height: 31px; width: 34px; padding: 0;">
                                <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" style="font-size:14px" />
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end shadow">
                                <li>
                                    <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="toggleTrashView">
                                        <AppIcon name="bi-trash" class="bi bi-trash me-2 text-danger" />
                                        <span>{{ $t('trash') }}</span>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <!-- Filters section -->
                    <div class="row align-items-end g-2 mb-4" v-if="!isDetailClient" :class="{'d-none d-md-flex': !showFilters}">
                        
                        <!-- Filter Dropdown (Shopify Style) -->
                        <div class="col-12 col-md-auto">
                            <div class="dropdown">
                                <button class="btn btn-outline-secondary dropdown-toggle btn-sm" type="button" id="orderFilterDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-funnel" class="bi bi-funnel" /> {{$t('filter')}}
                                    <span v-if="activeFilters.length" class="badge bg-secondary ms-1">{{activeFilters.length}}</span>
                                </button>
                                <button v-if="activeFilters.length" class="btn btn-link btn-sm text-danger text-decoration-none ms-2" type="button" @click.stop="clearAllFilters">
                                    <AppIcon name="bi-x-circle" class="bi bi-x-circle me-1" />{{$t('clear_all')}}
                                </button>
                                <div class="dropdown-menu p-3" aria-labelledby="orderFilterDropdown" style="min-width: 300px;" @click.stop>
                                    
                                    <!-- Active Filters -->
                                    <div v-if="activeFilters.length > 0" class="mb-3">
                                        <div v-for="(filter, index) in activeFilters" :key="index" class="mb-2">
                                            <label class="form-label small mb-1">{{$t(filter.key)}}</label>
                                            <div class="input-group input-group-sm" v-if="filter.key === 'total_amount'">
                                                <select v-model="filter.operator" class="form-select" style="max-width: 80px;">
                                                    <option value="gt">{{$t('operator_gt')}}</option>
                                                    <option value="lt">{{$t('operator_lt')}}</option>
                                                    <option value="eq">{{$t('operator_eq')}}</option>
                                                </select>
                                                <input type="number" v-model="filter.value" class="form-control form-control-sm" placeholder="0">
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                            <div class="input-group input-group-sm" v-else>
                                                <select v-model="filter.value" class="form-select form-select-sm">
                                                    <option v-for="option in getFilterOptions(filter.key)" :key="option.value" :value="option.value">
                                                        {{$t(option.label)}}
                                                    </option>
                                                </select>
                                                <button class="btn btn-outline-danger" type="button" @click="removeFilter(index)">
                                                    <AppIcon name="bi-trash" class="bi bi-trash" />
                                                </button>
                                            </div>
                                        </div>
                                        <hr class="dropdown-divider">
                                    </div>

                                    <!-- Add Filter Options -->
                                    <div class="d-grid gap-2">
                                        <button v-for="filter in selectableFilters" :key="filter.key" 
                                                class="btn btn-sm btn-outline-primary text-start" 
                                                @click="addFilter(filter)">
                                            <AppIcon name="bi-plus" class="bi bi-plus" /> {{$t(filter.key)}}
                                        </button>
                                    </div>

                                    <!-- Apply and Clear -->
                                    <div class="d-flex justify-content-between align-items-center mt-3">
                                        <button class="btn btn-sm btn-success" @click="applyFilters">
                                            {{$t('apply')}}
                                        </button>
                                        <button v-if="activeFilters.length > 0" class="btn btn-link btn-sm text-decoration-none text-danger p-0" @click="clearAllFilters">
                                            {{$t('clear_all')}}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Spacer for desktop -->
                        <div class="col d-none d-md-block"></div>
                        
                        <!-- Date picker -->
                        <div class="col-12 col-md-3 col-lg-2">
                            <label class="form-label small d-md-none mb-1">{{$t('filter_by_date')}}</label>
                            <select v-model="dateRangeOption" @change="handleDateRangeChange" class="form-select form-select-sm">
                                <option value="">{{$t('filter_by_date')}}</option>
                                <option value="today">{{$t('today')}}</option>
                                <option value="yesterday">{{$t('yesterday')}}</option>
                                <option value="this_week">{{$t('this_week')}}</option>
                                <option value="last_week">{{$t('last_week')}}</option>
                                <option value="this_month">{{$t('this_month')}}</option>
                                <option value="custom">{{$t('custom_date')}}</option>
                            </select>
                        </div>
                        <div class="col-12 col-md-3 col-lg-2" v-if="dateRangeOption === 'custom'">
                            <label class="form-label small d-md-none mb-1">{{$t('custom_date')}}</label>
                            <date-picker :clearable="true" :editable="false" class="w-100" v-model="range" type="date" range :multi-calendars="1" :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        
                    <!-- Desktop action buttons -->
                    <template v-if="helper.checkAccess('create_orders') != -1">
                        <div class="col-md-2 d-none d-md-block">
                            <button @click="create" class="btn btn-sm btn-success w-100">
                                <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                                <span>{{$t('order')}}</span>
                            </button>
                        </div>
                    </template>
                    
                    </div>

                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- Trash View -->
                    <div v-if="showTrash && (role === 'owner' || role === 'admin')" class="mt-5">
                        <div class="d-flex justify-content-between align-items-center mb-3">
                            <h6 class="mb-0"><AppIcon name="bi-trash" class="bi bi-trash me-2" />{{$t('trash')}}</h6>
                            <a href="#" class="text-decoration-none small d-flex align-items-center text-secondary" @click.prevent="toggleTrashView">
                                <AppIcon name="bi-arrow-left" class="bi bi-arrow-left me-1" />{{$t('back')}}
                            </a>
                        </div>
                        <table-loading-bar v-if="loading" class="text-center" />
                        <div v-if="!loading" class="table-responsive">
                            <table class="table mb-0 table-borderless table-striped small">
                                <thead>
                                    <tr class="text-secondary">
                                        <th class="pt-4 pb-3 px-6">{{$t('reference')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('client')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('date')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('total')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('deleted_at')}}</th>
                                        <th class="pt-4 pb-3 px-6">{{$t('actions')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in trashOrders" :key="item.id">
                                        <td class="py-5 px-6">{{item.reference}}</td>
                                        <td class="py-5 px-6">{{item.client ? item.client.name : '-'}}</td>
                                        <td class="py-5 px-6">{{formatDate(item.date)}}</td>
                                        <td class="py-5 px-6">{{formatMoney(item.total)}}</td>
                                        <td class="py-5 px-6">{{formatDate(item.deleted_at, true)}}</td>
                                        <td class="py-5 px-6">
                                            <button @click="ViewOrder(item)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                                <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                                {{$t('view')}}
                                            </button>
                                            <button v-if="helper.checkAccess('delete_orders') != -1" @click="permanentDeleteOrder(item)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-danger btn-xs">
                                                <AppIcon name="bi-x-circle" class="bi bi-x-circle" style="font-size:12px" />
                                                {{$t('delete_permanently')}}
                                            </button>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div v-if="!loading && trashOrders.length === 0" class="text-center py-4 text-muted">
                            <AppIcon name="bi-trash" class="bi bi-trash text-muted" style="font-size: 2rem;" />
                            <p class="mt-2 mb-0">{{$t('trash_empty')}}</p>
                        </div>
                        <div v-if="trashCount > trashOrders.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="trashPagination" :current-page="trashPage" @change="getTrashOrders" />
                        </div>
                    </div>


                    <div v-if="!showTrash">
                    <!-- Bulk Action Bar -->
                    <div v-if="isSelectedItem" class="position-fixed bottom-0 start-50 translate-middle-x mb-4 p-3 bg-white shadow rounded d-flex align-items-center gap-3" style="z-index: 1050; border: 1px solid #dee2e6; min-width: 300px; justify-content: space-between;">
                        <div class="d-flex align-items-center">
                            <span class="fw-bold me-2">{{ selectedCount }}</span>
                            <span class="text-muted">{{$t('selected')}}</span>
                        </div>
                        <div class="d-flex gap-2">
                            <div v-if="helper.checkAccess('create_invoices') > 0 || helper.checkAccess('create_deliveries') > 0" class="dropdown dropup">
                                <button class="btn btn-primary btn-sm dropdown-toggle d-flex align-items-center" type="button" id="bulkTransferDropdown" data-bs-toggle="dropdown" aria-expanded="false">
                                    <AppIcon name="bi-arrow-left-right" class="bi bi-arrow-left-right me-1" /> {{$t('transfert')}}
                                </button>
                                <ul class="dropdown-menu" aria-labelledby="bulkTransferDropdown">
                                    <li v-if="helper.checkAccess('create_invoices') > 0"><a class="dropdown-item" style="cursor:pointer" @click="transferSelectedToInvoice"> {{$t('invoice')}}</a></li>
                                    <li v-if="helper.checkAccess('create_deliveries') > 0"><a class="dropdown-item" style="cursor:pointer" @click="transferSelectedToDelivery"> {{$t('delivery')}}</a></li>
                                </ul>
                            </div>
                            <button v-if="helper.checkAccess('delete_orders') != -1" class="btn btn-danger btn-sm d-flex align-items-center" @click="deleteSelected">
                                <AppIcon name="bi-trash" class="bi bi-trash me-1" /> {{$t('delete')}}
                            </button>
                        </div>
                    </div>

                    <!-- table -->
                    <div data-testid="order-table-scroll" class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small sales-document-table" style="--sales-document-table-min-width: 1250px;">
                            <thead>
                                <tr class="text-secondary">
                                    <th class="pt-4 pb-3 px-6" style="width: 40px;">
                                        <div class="form-check mb-0">
                                            <input class="form-check-input" type="checkbox" :checked="areAllSelected" @change="toggleSelectAll">
                                        </div>
                                    </th>
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getOrders)" />
                                    <sortable-table-header field="total" label="total" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getOrders)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('total_products')}}</th>
                                    <sortable-table-header v-if="!hideClient" field="client" label="client" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getOrders)" />
                                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getOrders)" />
                                    <sortable-table-header field="created_by" label="created_by" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getOrders)" />
                                    <sortable-table-header field="date" label="order_date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getOrders)" />
                                    <th class="pt-4 pb-3 px-6 sales-sticky-action-cell">
                                        <div class="d-flex align-items-center justify-content-between">
                                            <span>{{$t('action')}}</span>
                                            <div v-if="role === 'owner' || role === 'admin'" class="dropdown">
                                                <button class="btn btn-sm btn-link p-0 ms-2 text-secondary" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                                                    <AppIcon name="bi-three-dots-vertical" class="bi bi-three-dots-vertical" />
                                                </button>
                                                <ul class="dropdown-menu dropdown-menu-end shadow">
                                                    <li>
                                                        <a class="dropdown-item d-flex align-items-center" href="#" @click.prevent="toggleTrashView">
                                                            <AppIcon name="bi-trash" class="bi bi-trash me-2 text-danger" />
                                                            <span>{{ $t('trash') }}</span>
                                                        </a>
                                                    </li>
                                                </ul>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="order in orders" :key="order.id" :class="{'table-active': order.selected}">
                                <td class="py-5 px-6">
                                    <div class="form-check mb-0">
                                        <input class="form-check-input" type="checkbox" v-model="order.selected" @change="changeSelectedItem">
                                    </div>
                                </td>
                                <td class="py-5 px-6"><router-link v-if="order.reference && order.reference" :to="`/orders/${order.id}`"><b>{{ order.reference }}</b></router-link></td>
                                <td class="py-5 px-6">{{formatMoney(calculateItemPrice(order))}} </td>
                                <td class="py-5 px-6">{{order.products.length}}</td>
                                <td v-if="!hideClient" class="py-5 px-6">
                                    <router-link
                                        v-if="order.client && order.client.id"
                                        :to="`/clients/${order.client.id}`"
                                        :title="order.client.name || '-'"
                                        :aria-label="order.client.name || '-'"
                                    >{{truncateClientName(order.client.name)}}</router-link>
                                </td>
                                 <td class="py-5 px-6">
                                    <div
                                        v-if="helper.checkAccess('edit_orders') != -1 && !['draft', 'canceled'].includes(order.status)"
                                        class="dropdown"
                                    >
                                        <button
                                            :id="`order-status-${order.id}`"
                                            type="button"
                                            class="badge border-0 dropdown-toggle"
                                            :class="getOrderStatusBadgeClass(order.status)"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                            :disabled="isOrderStatusDropdownDisabled(order)"
                                        >
                                            <span v-if="orderStatusUpdatingId === order.id" class="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true"></span>
                                            {{ $t(order.status) }}
                                        </button>
                                        <ul class="dropdown-menu shadow" :aria-labelledby="`order-status-${order.id}`">
                                            <li v-for="status in getOrderStatusOptions(order)" :key="status">
                                                <button
                                                    type="button"
                                                    class="dropdown-item d-flex align-items-center justify-content-between gap-3"
                                                    :class="{ active: order.status === status }"
                                                    :disabled="order.status === status"
                                                    @click="changeOrderStatus(order, status)"
                                                >
                                                    <span>{{ $t(status) }}</span>
                                                    <AppIcon name="bi-check-lg" v-if="order.status === status" class="bi bi-check-lg" />
                                                </button>
                                            </li>
                                        </ul>
                                    </div>
                                    <span v-else class="badge" :class="getOrderStatusBadgeClass(order.status)">
                                        {{ $t(order.status) }}
                                    </span>
                                </td>
                                <td class="py-5 px-6">
                                    {{ order.user ? order.user.name : '-' }}
                                </td>
                               
                                <td class="py-5 px-6">{{formatDate(order.date)}}</td>
                                <td class="py-5 px-6 sales-sticky-action-cell">
                                    <div class="sales-row-actions">
                                    <a :href="'/orders/'+order.id" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        {{$t('details')}}
                                    </a>
                                    <button v-if="false" @click="showDeliveries(order)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        {{$t('deliveries')}}
                                    </button>
                                    
                                    <button v-if="false" @click="showInvoices(order)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        {{$t('invoices')}}
                                    </button>
                                    <button v-if="order.status != 'draft'" @click="ViewOrder(order)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                        {{$t('purchase_order')}}
                                    </button>
                                    <button  v-if="helper.checkAccess('edit_orders') != -1" @click="editRow(order)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button  v-if="helper.checkAccess('delete_orders') != -1" @click="deleteRow(order)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                    </div>
                                </td>
                            </tr>
                            <tr v-if="orders.length" class="sales-total-row" style="background-color: #f8f9fa;font-weight: bold">
                                <td>{{$t('total')}}:</td>
                                <td></td>
                                <td class="py-5 px-6">{{formatMoney(orders.reduce((acc, item) => acc + calculateItemPrice(item), 0))}} </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td class="sales-sticky-action-cell"></td>
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="count > orders.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getOrders" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !orders.length && !isFiltered" class="page-table-state text-center py-5 my-5 bg-white rounded shadow-sm border" style="border-style: dashed !important;">
                        <AppIcon name="bi-cart" class="bi bi-cart text-muted" style="font-size: 3rem;" />
                        <h4 class="mt-3">{{ $t('no_orders_added') }}</h4>
                        <p class="text-muted">{{ $t('start_by_adding_orders') }}</p>
                        <template v-if="helper.checkAccess('create_orders') != -1">
                            <button class="btn btn-outline-primary mt-2" @click="create">
                                {{ $t('create_first_order') }}
                            </button>
                        </template>
                    </div>
                    <div v-if="loading === false && !orders.length && isFiltered" class="page-table-state text-center" style="padding:1rem">{{$t('no_order_found')}}.</div>

                </div>
                    </div>

                <div v-if="!showTrash" class="col-sm-7">
                                {{$t('show')}}
                                <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                    <option value="5">5</option>
                                    <option value="10">10</option>
                                    <option value="15">15</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                                {{$t('entities')}}
                            </div>
                </div>
        </section>



        <!-- create Modal -->
        <add-edit-order-modal 
            v-if="createModalisOpen" 
            @modalClosed="createModalisOpen = false"
            modalId="create-order-modal-01" 
            :isModalOpen="createModalisOpen" 
            :data="order" 
            action="create"
            @refresh="refresh"
        ></add-edit-order-modal>
        <!-- create modal -->

        <!-- Edit Modal -->
        <add-edit-order-modal 
            v-if="editModalisOpen" 
            @modalClosed="editModalisOpen = false" 
            modalId="edit-order-modal-01" 
            :isModalOpen="editModalisOpen"  
            :data="order" 
            action="update" 
            @refresh="refresh"
        ></add-edit-order-modal>
        <!-- Edit modal -->

        <!-- quote modal -->
        <invoice-template-modal 
            v-if="orderTemplateModalisOpen" 
            @modalClosed="orderTemplateModalisOpen = false" 
            modalId="invoice-order-modal-01" 
            :isModalOpen="orderTemplateModalisOpen"  
            :data="order" 
            type="order">
        </invoice-template-modal>
        <!-- quote modal -->

        <!-- create Modal -->
        <add-edit-invoice-modal 
            v-if="createInvoiceModalState" 
            @modalClosed="createInvoiceModalState = false"
            modalId="create-invoice-modal-01" 
            :isModalOpen="createInvoiceModalState" 
            :data="order" 
            action="transfer"
        ></add-edit-invoice-modal>
        <!-- create modal -->

        <!-- create Modal -->
        <add-edit-delivery-modal 
            v-if="createDeliveryModalState" 
            @modalClosed="createDeliveryModalState = false"
            modalId="create-delivery-modal-01" 
            :isModalOpen="createDeliveryModalState" 
            :data="order" 
            action="transfer"
        ></add-edit-delivery-modal>
        <!-- create modal -->

  </div>
</template>

<script>
import helper from '../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';


import AddEditOrderModal from './order/AddEditOrderModal'
import AddEditInvoiceModal from './invoice/AddEditInvoiceModal'
import AddEditDeliveryModal from './delivery/AddEditDeliveryModal'

import InvoiceTemplateModal from './invoiceLayout/InvoiceTemplateModal';
import sortableList from '../mixins/sortableList';


export default {
  name: 'OrderComponent',
  persistedFilterState: {
    key: 'orders',
    fields: ['activeFilters', 'dateRangeOption', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  props : [
    'client_id',
    'client',
    'user_id',
    'keyword',
    'isDetailClient',
    'showFilters'
  ],
  components : {
    DatePicker,
    AddEditOrderModal,
    AddEditInvoiceModal,
    AddEditDeliveryModal,
    InvoiceTemplateModal
  },
  data(){
    return {
        orders : [],
        count : 0,
        page : 1,
        showTrash : false,
        trashOrders : [],
        trashCount : 0,
        trashPage : 1,
        trashPagination : [],
        products : [],
        deliveries : [],
        invoices : [],
        order : {
            id : null,
            reference : `ORDER-00`,
            date : '',
            notes : '',
            products : [],
            client_id : null,
            client : {},
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
        invoiceData : {},
        range: [],
        start : null,
        end : null,
        dateRangeOption: '',
        delivery : {
            id : null,
            reference : `DEL-00`,
            date : '',
            notes : '',
            products : [],
            order_id : null,
            client_id : null,
            client : {},
            status : 'pending',
        },
        invoice : {
            id : null,
            reference : `I-00`,
            date : '',
            notes : '',
            products : [],
            client_id : null,
            client : {},
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
        activeFilters: [],
        availableFilters: [
            { 
                key: 'status', 
                options: [
                    { value: 'draft', label: 'draft' },
                    { value: 'pending', label: 'pending' },
                    { value: 'confirmed', label: 'confirmed' },
                    { value: 'completed', label: 'completed' },
                    { value: 'partially_delivered', label: 'partially_delivered' },
                    { value: 'canceled', label: 'canceled' }
                ] 
            },
            {
                key: 'total_amount',
                options: []
            }
        ],
        deliveryProducts : [],
        totalHtPrice : 0,
        purchasePrice : 0,
        loading : false,
        per_page : 25,
        pagination : [],
        invoiceType : 'order',
        hideClient : false,
        createModal : null,
        editModal : null,
        orderTemplateModalisOpen : false,
        orderShowInvoiceModalisOpen : false,
        orderInvoiceModalisOpen : false,
        editTransactionModalisOpen : false,
        createModalisOpen :false,
        showDilveriesModalisOpen : false,
        createClientState : false,
        editModalisOpen :false,
        isSelectedItem: false,
        createInvoiceModalState: false,
        createDeliveryModalState: false,
        orderStatusUpdatingId: null,
        orderStatusOptions: ['pending', 'confirmed', 'canceled']
    }   
  },
  mounted(){
    // Initialize this_month date range
    // this.handleDateRangeChange()
    this.getOrders()
    if(this.isOwner) this.getTrashCount()
  },
  watch : {
    createModalisOpen(){
        this.getOrders()
    },
    range(val) {
        if (val && val.length === 2 && val[0] && val[1]) {
            this.start = moment(val[0]).format('YYYY-MM-DD')
            this.end = moment(val[1]).format('YYYY-MM-DD')
            this.getOrders(1)
        } else {
            this.start = null
            this.end = null
            this.getOrders(1)
        }
    },
    per_page(){
        this.getOrders(this.page)
    },
    async keyword(){
        if(this.keyword.length > 2){
            const response = await helper.customGet(`${process.env.VUE_APP_API}/orders?keyword=${this.keyword}&per_page=${this.per_page}`)
            this.orders = response.data.data
            for(let i = 0 ; i < this.orders.length ; i++){
                this.$set(this.orders[i], 'selected', false)
            }
            this.count = response.data.count
        }
        if(this.keyword == '') return this.getOrders()
    },
  },    
  methods : {
    truncateClientName(name) {
        if (!name) return '-'
        return name.length > 20 ? `${name.slice(0, 20)}...` : name
    },
    async create(){

        this.clearForm()
        
        if(this.client_id){
            this.order.client_id = this.client_id
        }

        if(this.client){
            this.order.client = this.client
        }

        this.order.products.push({
            label : '',
            id : null,
            quantity : 0,
            price : 0,
            discount : 0,
            vat : this.business.vat,
            total : 0,
            sub_total : 0,
        })
        this.createModalisOpen = true;

        this.order.date = moment().format('YYYY-MM-DD')
    },
    editRow(row){
        this.editModalisOpen = true;
        this.clearForm()
        this.order = row 
        this.order.client_id = row.client && row.client.id ? row.client.id : null
        this.order.date = moment(this.order.date).format('YYYY-MM-DD')
    },
    ViewOrder(row){
        this.order = {}
        this.order = row 
        this.orderTemplateModalisOpen = true;    
    },
    showInvoices(row){
        this.clearForm()
        this.order = null
        this.order = row 
        this.invoiceType = 'order'
        this.orderShowInvoiceModalisOpen = true;
        this.getInvoices(this.order.id)
    },
    async deleteRow(row){
            this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/orders/${row.id}`)
                    this.orders = helper.withoutDeletedRecords(this.orders, row.id)
                    this.count = Math.max(0, this.count - 1)
                }
            })
    },
    clearForm(){
        this.order = {
            id : null,
            reference : '',
            date : '',
            products : [],
            payment_method : 'cash',
            status : 'pending',
            rest : 0,
            total : 0,
            amount_paid : 0,
        }

    },
    async getOrders(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            
            // Extract filters
            const statusFilter = this.activeFilters.find(f => f.key === 'status');
            const status = statusFilter ? statusFilter.value : 'all';

            const amountFilter = this.activeFilters.find(f => f.key === 'total_amount');

            // Build query params
            const params = new URLSearchParams();
            params.append('page', this.page);
            params.append('per_page', this.per_page);
            this.appendSortParams(params);

            if (this.start) {
                params.append('start', this.start);
                params.append('end', this.end);
            }

            if (status !== 'all') params.append('status', status);
            
            if (amountFilter && amountFilter.value !== null && amountFilter.value !== '') {
                params.append('amount_operator', amountFilter.operator);
                params.append('amount_value', amountFilter.value);
            }
            
            // Add optional filters if they exist
            if (this.client_id) params.append('client_id', this.client_id);
            if (this.user_id) params.append('user_id', this.user_id);
            if (this.keyword && this.keyword.length > 2) params.append('keyword', this.keyword);

            let url = `${process.env.VUE_APP_API}/orders?${params.toString()}`;

            const response = await helper.customGet(url)
            this.orders = response.data.data
            for(let i = 0 ; i < this.orders.length ; i++){
                this.$set(this.orders[i], 'selected', false)
            }
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }

            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
            
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    getOrderStatusBadgeClass(status){
        return {
            'bg-info': status === 'draft',
            'bg-success': ['confirmed', 'completed'].includes(status),
            'bg-warning': status === 'partially_delivered',
            'bg-danger': status === 'canceled',
            'bg-secondary': status === 'pending'
        }
    },
    getOrderStatusOptions(order){
        return ['confirmed', 'completed', 'partially_delivered'].includes(order.status)
            ? ['canceled']
            : this.orderStatusOptions
    },
    isOrderStatusDropdownDisabled(order){
        return this.orderStatusUpdatingId === order.id
            || ['draft', 'canceled'].includes(order.status)
    },
    async changeOrderStatus(order, status){
        if (this.isOrderStatusDropdownDisabled(order) || order.status === status) return

        const previousStatus = order.status
        this.orderStatusUpdatingId = order.id
        this.$set(order, 'status', status)

        try{
            await helper.customPatch(
                `${process.env.VUE_APP_API}/orders/${order.id}`,
                { status },
                { showToast: true }
            )
        }catch(error){
            this.$set(order, 'status', previousStatus)
        }finally{
            await this.getOrders(this.page)
            this.orderStatusUpdatingId = null
        }
    },
    calculateItemPrice(order){
        if(order.status == "draft") return 0
        return order.products && order.products.length ? order.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0; 
    },
    async getDeliveries(id){
        try{
            this.loading = true
            this.deliveries = []
            const response = await helper.customGet(`${process.env.VUE_APP_API}/deliveries?order_id=${id}`)
            this.deliveries = response.data.data
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    async showDeliveries(order){
        this.order = order
        this.showDilveriesModalisOpen = true
        await this.getDeliveries(order.id)
    },
    async getInvoices(id){
        try{
            this.loading = true
            this.invoices = []
            const response = await helper.customGet(`${process.env.VUE_APP_API}/invoices?order_id=${id}`)
            this.invoices = response.data.data
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    refresh(){
        this.getOrders()
    },
    //helper functions
    formatDate(date) { return helper.formatDate(date) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);},
    // Handle date range selection
    handleDateRangeChange() {
      const option = this.dateRangeOption
      if (!option || option === 'custom') {
        if (option === 'custom') return
        this.range = []
        this.start = null
        this.end = null
        this.getOrders()
        return
      }

      const today = moment()
      let start, end

      switch(option) {
        case 'today':
          start = today.clone().startOf('day')
          end = today.clone().endOf('day')
          break
        case 'yesterday':
          start = today.clone().subtract(1, 'days').startOf('day')
          end = today.clone().subtract(1, 'days').endOf('day')
          break
        case 'this_week':
          start = today.clone().startOf('isoWeek')
          end = today.clone().endOf('isoWeek')
          break
        case 'last_week':
          start = today.clone().subtract(1, 'weeks').startOf('isoWeek')
          end = today.clone().subtract(1, 'weeks').endOf('isoWeek')
          break
        case 'this_month':
          start = today.clone().startOf('month')
          end = today.clone().endOf('month')
          break
        default:
          return
      }

      this.range = [start.toDate(), end.toDate()]
      this.start = start.format('YYYY-MM-DD')
      this.end = end.format('YYYY-MM-DD')
      this.getOrders()
    },
    addFilter(filter) {
        if (!this.isFilterActive(filter.key)) {
            if (filter.key === 'total_amount') {
                 this.activeFilters.push({
                    key: filter.key,
                    operator: 'gt',
                    value: 0
                });
            } else {
                const defaultVal = filter.options[0].value;
                this.activeFilters.push({ 
                    key: filter.key, 
                    value: defaultVal 
                });
            }
        }
    },
    removeFilter(index) {
        this.activeFilters.splice(index, 1);
    },
    isFilterActive(key) {
        return this.activeFilters.some(f => f.key === key);
    },
    getFilterOptions(key) {
        const filter = this.availableFilters.find(f => f.key === key);
        return filter ? filter.options : [];
    },
    applyFilters() {
        this.getOrders();
    },
    clearAllFilters() {
        this.activeFilters = [];
        this.getOrders();
    },
    changeSelectedItem(){
        this.isSelectedItem = this.orders.find(item => item.selected === true ) ? true : false
    },
    toggleSelectAll() {
      const newState = !this.areAllSelected;
      this.orders.forEach(item => item.selected = newState);
      this.changeSelectedItem();
    },
    async deleteSelected() {
      const selectedIds = this.orders.filter(item => item.selected).map(item => item.id);
      if (selectedIds.length === 0) return;

      this.$swal.fire({
        title: `${this.$t('are_you_sure')}?`,
        text: this.$t('you_cant_revert'),
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: this.$t('yes_delete_it')
      }).then(async (result) => {
        if (result.isConfirmed) {
            this.loading = true;
            try {
                const results = await Promise.allSettled(selectedIds.map(id => helper.customDelete(`${process.env.VUE_APP_API}/orders/${id}`)));
                const deletedIds = helper.fulfilledRecordIds(selectedIds, results);
                this.orders = helper.withoutDeletedRecords(this.orders, deletedIds);
                this.count = Math.max(0, this.count - deletedIds.length);
                if (deletedIds.length !== selectedIds.length) throw results.find(result => result.status === 'rejected').reason;
                this.isSelectedItem = false;
                this.$toast.open({
                    message: this.$t('orders_deleted_successfully'),
                    type: 'success',
                    position: 'bottom'
                });
            } catch (error) {
                this.$toast.open({
                    message: this.$t('error_occurred'),
                    type: 'error',
                    position: 'bottom'
                });
            } finally {
                this.loading = false;
            }
        }
      });
    },
    validateBulkTransfer() {
        const selectedOrders = this.orders.filter(item => item.selected);
        if (selectedOrders.length === 0) return null;

        const clientId = selectedOrders[0].client_id;
        const allSameClient = selectedOrders.every(o => o.client_id === clientId);

        if (!allSameClient) {
            this.$swal.fire(
                this.$t('error'),
                this.$t('select_orders_same_client'),
                'error'
            );
            return null;
        }
        
        // Aggregate products
        let allProducts = [];
        selectedOrders.forEach(o => {
            if (o.products && o.products.length) {
                allProducts = allProducts.concat(o.products);
            }
        });

        // Calculate total
        const total = allProducts.reduce((acc, p) => acc + (p.total || 0), 0);

        return {
            id: null,
            order_ids: selectedOrders.map(o => o.id),
            client_id: clientId,
            status : 'pending',
            client: selectedOrders[0].client,
            date: moment().format('YYYY-MM-DD'),
            products: allProducts,
            total: total
        };
    },
    transferSelectedToInvoice() {
        const mergedData = this.validateBulkTransfer();
        if (!mergedData) return;

        this.order = mergedData;
        this.createInvoiceModalState = true;
    },
    transferSelectedToDelivery() {
        const mergedData = this.validateBulkTransfer();
        if (!mergedData) return;

        this.order = mergedData;
        this.createDeliveryModalState = true;
    },
    async toggleTrashView() {
        this.showTrash = !this.showTrash;
        if (this.showTrash) {
            this.trashPage = 1;
            await this.getTrashOrders(1);
        }
    },
    async getTrashCount() {
        // Optional tracking
    },
    async getTrashOrders(page) {
        try {
            this.loading = true;
            this.trashPage = page ? page : 1;
            const url = `${process.env.VUE_APP_API}/orders/trash?page=${this.trashPage}&per_page=50`;
            const response = await helper.customGet(url);
            this.trashOrders = response.data.data;
            this.trashCount = response.data.count;
            
            this.trashPagination = [];
            let MaxPagination = Math.ceil(this.trashCount / 50);
            for(let i = 1; i <= MaxPagination; i++) {
                this.trashPagination.push(i);
            }
        } catch (error) {
            helper.handleError(error);
        } finally {
            this.loading = false;
        }
    },
    async permanentDeleteOrder(item) {
        this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text: this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#6c757d',
            confirmButtonText: this.$t('yes_delete_it')
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await helper.customDelete(`${process.env.VUE_APP_API}/orders/${item.id}/permanent`);
                    this.trashOrders = helper.withoutDeletedRecords(this.trashOrders, item.id);
                } catch (error) {
                    helper.handleError(error);
                }
            }
        });
    }
  },
  computed : {
    selectableFilters() {
        return this.availableFilters.filter(f => !this.isFilterActive(f.key));
    },
    isFiltered() {
      return (this.activeFilters.length > 0) ||
             (this.dateRangeOption && this.dateRangeOption !== '') ||
             (this.keyword && this.keyword.length > 0) ||
             (this.range && this.range.length > 0);
    },
    isOwner(){ return ['owner', 'admin'].includes(this.$store.getters.ROLE) },
    business(){ return this.$store.getters.BUSINESS},
    role(){ return this.$store.getters.ROLE },
    helper(){ return helper },
    permissions(){ return this.$store.getters.PERMISSIONS },
    total(){ return this.order.products.length ? this.order.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.order.products.length ? this.order.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0},
    selectedCount() {
      return this.orders.filter(item => item.selected).length;
    },
    areAllSelected() {
      return this.orders.length > 0 && this.orders.every(item => item.selected);
    }
  },
}
</script>
<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
